import React, { Component } from "react";
import AsyncComponent from "../../../components/async-component";
import PageWrap from "../../../components/page-wrap";
import PageContent from "../../../components/page-content";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import { PersonelContextProvider } from "./context/personel-context";

class BSPersonel extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <PersonelContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </PersonelContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default BSPersonel;
